import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import { PayloadAction } from '@reduxjs/toolkit';
import { NotifyService } from 'helpers';
import { ResponseType } from 'models';
import {
  AC_ACTIVITY_LOG_LIST_PARAMS,
  ACTIVITY_LOGS_RESULT,
} from 'models/activity-logs';
import { getActivityLogsApi } from 'services/activity-logs';
import { setActivityLogListSuccess } from 'store/reducers/activity-logs';
import { GET_ACTIVITY_LOG_LIST_REQUEST } from 'store/reducers/activity-logs/actionTypes';
import { setGlobalLoading } from 'store/reducers/global';

function* setActivityLogListRequest(
  action: PayloadAction<{
    data?: AC_ACTIVITY_LOG_LIST_PARAMS;
    onSuccess?: () => void;
    onFailed?: () => void;
  }>
) {
  try {
    yield put(setGlobalLoading(true));
    const response: AxiosResponse<ResponseType<ACTIVITY_LOGS_RESULT>> =
      yield call(getActivityLogsApi, action.payload.data);
    yield put(
      setActivityLogListSuccess({
        records: response.data.data.records,
        metadata: response.data.data.metadata,
      })
    );
    yield put(setGlobalLoading(false));
  } catch (error: any) {
    NotifyService.error(error);
    yield put(setGlobalLoading(false));
  }
}

function* activityLogs() {
  yield takeLatest(GET_ACTIVITY_LOG_LIST_REQUEST, setActivityLogListRequest);
}

export default activityLogs;
